
  <div class="chart">
    <canvas id="lineChart" #lineChart>{{chart}}</canvas>
  </div>

  <div class="carga"  *ngIf="(!this.flagCargaGrafica)"> 
    <h1> CARGANDO DATOS...</h1>
    <mat-spinner class="spinner"></mat-spinner> 
  </div>